<template lang="pug">
  lei-modal.challenge-modal(@close="toggleModal(false)" :title="title" size="md" :close-with-overlay="false")
    challenge-compare-block(
      :needTip="false"
      :value="date"
      :jsonPath="dateJsonPath"
      :oldValue="oldDate"
      @change="value => date = value"
      label="Propose Expiration Date"
      labelForOld="Old Expiration Date")
    .container
      p.description {{dateDescription}}
    challenge-compare-block(
      :needTip="false"
      :value="reason"
      :jsonPath="reasonJsonPath"
      :oldValue="oldReason"
      @change="value => reason = value"
      label="Propose Expiration Reason"
      labelForOld="Old Expiration Reason")
    .container
      p.description {{reasonDescription}}
    comment-input(@input="comment=$event")
    div(slot="footer")
      lei-btn(type="cyprus" fill @click="save" :disabled="disabled") Save
</template>
<script>
import { mapState, mapMutations, mapActions, } from 'vuex'
import LeiModal from '../lei-components/LeiModal'
import ChallengeCompareBlock from '../challenge-components/ChallengeCompareBlock'
import LeiBtn from '../lei-components/LeiBtn'
import { TOGGLE_CHALLENGE_EXPIRATION_MODAL, SAVE_FIELD, } from '@/store/modules/record/modules/challenge/mutations-types'
import { getFieldIdByPath, getTextByPath, } from '@/utils/challenge'
import CommentInput from '@/components/lei-components/inputs/CommentInput'

export default {
  components: {
    CommentInput,
    LeiBtn,
    LeiModal,
    ChallengeCompareBlock,
  },
  data () {
    return {
      comment: {
        value: '',
        valid: true,
      },
      date: null,
      reason: null,
      dateJsonPath: '$.entity.expiration.date',
      reasonJsonPath: '$.entity.expiration.reason',
    }
  },
  computed: {
    jsonPath () {
      return this.challenge.jsonPath
    },
    expiration () {
      return this.challenge.oldValue
    },
    oldDate () {
      return this.expiration ? this.expiration.date : null
    },
    oldReason () {
      return this.expiration ? this.expiration.reason : null
    },
    dateDescription () {
      return getTextByPath(this.dateJsonPath)
    },
    reasonDescription () {
      return getTextByPath(this.reasonJsonPath)
    },
    dateId () {
      return getFieldIdByPath(this.dateJsonPath)
    },
    reasonId () {
      return getFieldIdByPath(this.reasonJsonPath)
    },
    disabled () {
      return !this.date || !this.reason || !this.comment.valid
    },
    title () {
      return `Challenge: ${this.challenge.title}`
    },

    ...mapState('record/challenge', [ 'challenge', ]),
    ...mapState('search', [ 'filters', ]),
  },
  watch: {
    needAlternative () {
      this.value = ''
    },
  },
  methods: {
    async save () {
      const { date, reason, oldDate, oldReason, } = this
      const dateField = await this.getField(this.dateId)
      const reasonField = await this.getField(this.reasonId)
      this.checkAndSaveFields(date, oldDate, dateField.xpath, 'date')
      this.checkAndSaveFields(reason, oldReason, reasonField.xpath, 'reason')
      this.toggleModal(false)
    },
    checkAndSaveFields (newValue, oldValue, xpath, type) {
      if (oldValue !== newValue) {
        this.saveField({
          original_value: oldValue,
          proposed_value: newValue,
          field: xpath,
          comment: this.comment.value,
          jsonPath: `${this.jsonPath}.${type}`,
        })
      }
    },

    ...mapMutations('record/challenge', {
      toggleModal: TOGGLE_CHALLENGE_EXPIRATION_MODAL,
      saveField: SAVE_FIELD,
    }),
    ...mapActions('record/challenge', [ 'getField', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .challenge-modal
    &.modal
      z-index 102

    .description
      text-align justify
      color $default-color
      line-height 1.25
      margin-bottom 20px

  @media (min-width: $laptop)
    .challenge-modal
      .container
        margin-bottom 25px

        &:last-child
          margin-bottom 0

</style>



// WEBPACK FOOTER //
// src/components/modals/ChallengeExpirationModal.vue